(() => {
  const initializeBundleTracker = () => {

  // Prevent the script from loading multiple times and conflicting

  if (window.__masterBundleTrackerActive) return;

  window.__masterBundleTrackerActive = true;



  // Track the specific bundle the user is interacting with

  window.__kachingActiveContext = "";

  window.__kachingActiveProductKey = "";

 

  const normalizeText = (value) => String(value || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

  const getCardTitle = (card) => normalizeText(
    card?.querySelector('.kaching-bundles__bar-title, .kaching-bundle-title, .kaching-bundle-card-title')?.textContent ||
    card?.textContent
  );

  const getBlockProduct = (block) => {
    try {
      return JSON.parse(block?.getAttribute('product') || '{}');
    } catch (_) {
      return {};
    }
  };

  const findBundleContextAround = (startNode) => {
    let context = startNode;

    while (context && context !== document.body) {
      const blocks = context.querySelectorAll?.('kaching-bundles-block');
      if (blocks?.length === 1) {
        return {
          block: blocks[0],
          card: blocks[0].querySelector('.kaching-bundles__bar--selected')
        };
      }

      const oldCards = context.querySelectorAll?.('.kaching-bundle-card-selected');
      if (oldCards?.length === 1) return { block: null, card: oldCards[0] };

      context = context.parentElement;
    }

    return null;
  };

  const resolveBundleContext = (startNode, clickedCard = null) => {
    const clickedBlock = clickedCard?.closest?.('kaching-bundles-block') || null;
    const nearby = clickedBlock
      ? { block: clickedBlock, card: clickedCard }
      : findBundleContextAround(startNode);

    if (!nearby) return { activeText: '', productKey: '' };

    const product = getBlockProduct(nearby.block);
    return {
      activeText: getCardTitle(nearby.card) || normalizeText(product.title),
      productKey: normalizeText(product.handle)
    };
  };

  const saveBundleContext = (bundleContext) => {
    window.__kachingActiveContext = bundleContext.activeText;
    window.__kachingActiveProductKey = bundleContext.productKey;
  };

  document.addEventListener('click', (e) => {
    // Capture the exact bar being selected. When Add to Cart is clicked,
    // find the one selected bar inside that button's product section.
    const clickedCard = e.target.closest?.('.kaching-bundles__bar, .kaching-bundle-card');
    saveBundleContext(resolveBundleContext(e.target, clickedCard));
  }, true);



  // 1. CONFIGURATION DICTIONARY - STRICT NAME TARGETING

  const BUNDLE_RULES = {

    'essential-back-pad': [

      { keywords: ['essential back pad + two half wraps', '2 essential half wraps & essential back', 'two half wraps'], tag: 'essentialbackpad_two_half_wraps' },

      { keywords: ['essential back pad + half wrap', 'essential half wrap + essential pad', 'essential half wrap + essential back pad', 'add a half wrap'], tag: 'essentialbackpad_half_wrap' },

      { keywords: ['1 essential back pad', 'single essential back pad'], tag: 'essentialbackpad_single' }

    ],

    'essential-line-essential-half-wrap': [

      { keywords: ['2 essential half wraps & essential back', '2 essential half wraps +'], tag: 'essentialwrap_2_wraps_and_mat' },

      { keywords: ['essential half wrap + essential pad', 'essential half wrap + essential back pad'], tag: 'essentialwrap_mat_and_wrap' },

      { keywords: ['2 essential half wraps', 'another half wrap'], tag: 'essentialwrap_2_wraps' },

      { keywords: ['1 essential half wrap', 'single essential half wrap'], tag: 'essentialwrap_single' }

    ],

    'illumi-vet-5000': [

      { keywords: ['magic mat + illumi vet 5000 & horse book', 'illumi vet 5000 & horse book', 'illumi vet 5000 + magic mat & horse book'], tag: 'illumivet5000_magicmat_horse_book' },

      { keywords: ['magic mat + illumi vet 5000 & dog book', 'illumi vet 5000 & dog book', 'illumi vet 5000 + magic mat & dog book'], tag: 'illumivet5000_magicmat_dog_book' },

      { keywords: ['illumi-vet 5000 deluxe kit', 'illumi vet 5000 deluxe kit'], tag: 'illumivet5000_deluxe_kit' },

      { keywords: ['illumi-vet 5000 acl tear kit', 'illumi vet 5000 acl tear kit'], tag: 'illumivet5000_acl_kit' },

      { keywords: ['illumi-vet 5000 horse kit', 'illumi vet 5000 horse kit'], tag: 'illumivet5000_horse_kit' },

      { keywords: ['illumi-vet 5000 dog kit', 'illumi vet 5000 dog kit'], tag: 'illumivet5000_dog_kit' },

      { keywords: ['illumi-vet 5000', 'illumi vet 5000'], tag: 'illumivet5000_single' }

    ],

    'illumi-vet-3000': [

      { keywords: ['illumi-vet 3000 deluxe kit', 'illumi vet 3000 deluxe kit', 'deluxe kit'], tag: 'illumivet3000_deluxe_kit' },

      { keywords: ['illumi-vet 3000 acl tear kit', 'illumi vet 3000 acl tear kit', 'acl tear kit'], tag: 'illumivet3000_acl_kit' },

      { keywords: ['illumi-vet 3000 horse kit', 'illumi vet 3000 horse kit', 'horse kit'], tag: 'illumivet3000_horse_kit' },

      { keywords: ['illumi-vet 3000 dog kit', 'illumi vet 3000 dog kit', 'dog kit'], tag: 'illumivet3000_dog_kit' },

      { keywords: ['illumi-vet 3000', 'illumi vet 3000'], tag: 'illumivet3000_single' }

    ],

    'magic-wrap': [

      { keywords: ['2 magic wraps + magic mat', '2 magic wraps and magic mat'], tag: 'magicwrap_2_wraps_and_mat' },

      { keywords: ['magic wrap & magic mat', 'magic wrap and magic mat', 'magic mat & magic wrap'], tag: 'magicwrap_mat_and_wrap' },

      { keywords: ['2 magic wraps'], tag: 'magicwrap_2_wraps' },

      { keywords: ['1 magic wrap', 'single magic wrap'], tag: 'magicwrap_single' }

    ],

    'magic-mat-professional-trade-in': [

      { keywords: ['trade-in', 'wrap'], tag: 'magicmattradein_mat_and_2_wraps' },

      { keywords: ['2 magic mats'], tag: 'magicmattradein_2_mats' }

    ],

    'magic-mat': [

      { keywords: ['magic mat + multi light & horse book', 'magic mat + multi-light & horse book'], tag: 'magicmat_multilight_horse_book' },

      { keywords: ['magic mat + multi light & dog book', 'magic mat + multi-light & dog book'], tag: 'magicmat_multilight_dog_book' },

      { keywords: ['magic mat + illumi vet 5000 & horse book'], tag: 'magicmat_illumivet5000_horse_book' },

      { keywords: ['magic mat + illumi vet 5000 & dog book'], tag: 'magicmat_illumivet5000_dog_book' },

      { keywords: ['magic mat & 2 magic wrap combo', 'magic mat and 2 magic wraps'], tag: 'magicmat_mat_and_2_wraps' },

      { keywords: ['magic mat & magic wrap combo', 'magic mat and magic wrap'], tag: 'magicmat_mat_and_wrap' },

      { keywords: ['1 magic mat', 'single magic mat'], tag: 'magicmat_single' }

    ],

    'multi-light-tsc': [

      { keywords: ['magic mat + multi-light & horse book', 'magic mat & horse book', 'magic mat + multi light & horse book'], tag: 'multilight_magicmat_horse_book' },

      { keywords: ['magic mat + multi-light & dog book', 'magic mat & dog book', 'magic mat + multi light & dog book'], tag: 'multilight_magicmat_dog_book' },

      { keywords: ['multi-light deluxe kit', 'multi light deluxe kit', 'deluxe kit'], tag: 'multilight_deluxe_kit' },

      { keywords: ['multi-light acl tear kit', 'multi light acl tear kit', 'acl tear kit'], tag: 'multilight_acl_kit' },

      { keywords: ['multi-light horse kit', 'multi light horse kit', 'horse kit'], tag: 'multilight_horse_kit' },

      { keywords: ['multi-light dog kit', 'multi light dog kit', 'dog kit'], tag: 'multilight_dog_kit' },

      { keywords: ['multi-light', 'multi light'], tag: 'multilight_single' }

    ],

    'pro-gen-ii-tsc': [

      { keywords: ['pro gen ii deluxe kit', 'deluxe kit'], tag: 'progen2_deluxe_kit' },

      { keywords: ['pro gen ii acl tear kit', 'acl tear kit'], tag: 'progen2_acl_kit' },

      { keywords: ['pro gen ii horse kit', 'horse kit'], tag: 'progen2_horse_kit' },

      { keywords: ['pro gen ii dog kit', 'dog kit'], tag: 'progen2_dog_kit' },

      { keywords: ['pro gen ii'], tag: 'progen2_single' }

    ],

    'standard-light-tsc': [

      { keywords: ['standard light deluxe kit', 'deluxe kit'], tag: 'standardlight_deluxe_kit' },

      { keywords: ['standard light acl tear kit', 'acl tear kit'], tag: 'standardlight_acl_kit' },

      { keywords: ['standard light horse kit', 'horse kit'], tag: 'standardlight_horse_kit' },

      { keywords: ['standard light dog kit', 'dog kit'], tag: 'standardlight_dog_kit' },

      { keywords: ['standard light'], tag: 'standardlight_single' }

    ]

  };


  const findBestTag = (rules, activeText) => {

    let bestMatch = null;

    for (const rule of rules) {

      for (const keyword of rule.keywords) {

        const normalizedKeyword = normalizeText(keyword);

        if (normalizedKeyword && activeText.includes(normalizedKeyword)) {

          if (!bestMatch || normalizedKeyword.length > bestMatch.length) {

            bestMatch = { tag: rule.tag, length: normalizedKeyword.length, ambiguous: false };

          } else if (normalizedKeyword.length === bestMatch.length && rule.tag !== bestMatch.tag) {

            bestMatch.ambiguous = true;

          }

        }

      }

    }

    return bestMatch && !bestMatch.ambiguous ? bestMatch.tag : null;

  };



  const originalFetch = window.fetch;



  window.fetch = async function(...args) {

    let [resource, config] = args;



    // Intercept Add to Cart requests

    if (typeof resource === 'string' && resource.includes('/cart/add') && config?.body) {

      try {

        const path = window.location.pathname.toLowerCase();

       

        // 2. IDENTIFY CONTEXT

        const productKey = Object.keys(BUNDLE_RULES).find(key => path.includes(key));

        const isHolidaySpecials = path.includes('holiday-specials');

       

        if (productKey || isHolidaySpecials) {

         

          let activeText = window.__kachingActiveContext;

          let activeProductKey = window.__kachingActiveProductKey;

          // At fetch time, the Add to Cart button is normally still focused.
          // Re-resolve its product section so Holiday Specials never depends
          // on context left behind by a different product.
          const liveContext = resolveBundleContext(document.activeElement);
          if (liveContext.activeText || liveContext.productKey) {
            activeText = liveContext.activeText;
            activeProductKey = liveContext.productKey;
            saveBundleContext(liveContext);
          }

         

          // Fallback: strictly find active elements, don't read the whole page.

          if (!activeText) {

             const fallbackCards = document.querySelectorAll('kaching-bundles-block .kaching-bundles__bar--selected, .kaching-bundle-card-selected');

             if (fallbackCards.length === 1) {

                activeText = getCardTitle(fallbackCards[0]);

             }

          }



          // 3. DETERMINE TAG

          let finalTag = null;

         

          if (isHolidaySpecials && activeText) {

            // On Holiday Specials, use only the rules for the product block
            // surrounding the clicked Add to Cart button whenever possible.

            const holidayRules = BUNDLE_RULES[activeProductKey] || Object.values(BUNDLE_RULES).flat();
            finalTag = findBestTag(holidayRules, activeText);

          } else if (productKey && activeText) {

            // Standard individual product page check

            finalTag = findBestTag(BUNDLE_RULES[productKey], activeText);

          }



          // 4. PAYLOAD INJECTION

          if (finalTag) {

            if (config.body instanceof FormData) {

              config.body.append('properties[__bundle-ids]', finalTag);

            } else if (config.body instanceof URLSearchParams) {

              config.body.set('properties[__bundle-ids]', finalTag);

            } else if (typeof config.body === 'string') {

              try {

                let data = JSON.parse(config.body);

               

                const injectProperty = (item) => {

                  item.properties = item.properties || {};

                  item.properties['__bundle-ids'] = finalTag;

                  return item;

                };



                if (data.items && Array.isArray(data.items)) {

                  data.items = data.items.map(injectProperty);

                } else {

                  data = injectProperty(data);

                }

                config.body = JSON.stringify(data);

               

              } catch (e) {

                if (config.body.includes('id=')) {

                  config.body += `&properties[__bundle-ids]=${encodeURIComponent(finalTag)}`;

                }

              }

            }

          }

        }

      } catch (e) {

        console.error("Master bundle tracking error handled silently:", e);

      }

    }



    return originalFetch.apply(this, args);

  };

  };

  // Theme app blocks can insert this script after DOMContentLoaded has fired.

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initializeBundleTracker, { once: true });

  } else {

    initializeBundleTracker();

  }

})();